import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GetParam } from "../../pkg/query/getparam";
import { HOME } from "../../pkg/query/parameters";

const Content = (props) => {
  const __html = props.__html;
  const location = useLocation();
  const currentParam = GetParam(location.search);
  const isHomePage = currentParam === HOME;
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleClick = (e) => {
      const link = e.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      const isGoogleForm = href.includes("docs.google.com/forms");

      if (isGoogleForm && window.gtag) {
        window.gtag("event", "form_link_click", {
          event_category: "engagement",
          event_label: href,
          page_path: location.pathname + location.search,
        });
      }
    };

    container.addEventListener("click", handleClick);
    return () => container.removeEventListener("click", handleClick);
  }, [__html, location]);

  return (
    <section className={`section ${isHomePage ? 'content-animate' : 'content-detail'}`}>
      <div className="box hover-lift">
        <div ref={containerRef} className="container" dangerouslySetInnerHTML={{ __html }} />
      </div>
    </section>
  );
};

export default Content;
